import { makeAutoObservable, runInAction } from "mobx";
import { targetSetupOverviewService } from "../services/target-setup-overview.service";

class TargetSetupOverviewStore {
  items = [];
  loading = false;
  hasLoadedOnce = false;
  error = null;

  constructor() {
    makeAutoObservable(this);
  }

  // Partially-filled metrics (some orgs filled, some not) belong in both
  // buckets — they represent outstanding work (unfilled) and captured
  // progress (filled) at the same time.
  get filledItems() {
    return this.items.filter((item) => (item.filledOrgs ?? 0) > 0);
  }

  get unfilledItems() {
    return this.items.filter(
      (item) => (item.filledOrgs ?? 0) < (item.totalOrgs ?? 0),
    );
  }

  load = async ({ years, frameworks, categories, orgIds } = {}) => {
    this.loading = true;
    this.error = null;
    try {
      const data = await targetSetupOverviewService.getList({
        years,
        frameworks,
        categories,
        orgIds,
      });
      runInAction(() => {
        this.items = data?.items ?? [];
        this.hasLoadedOnce = true;
      });
    } catch (err) {
      runInAction(() => {
        this.error = err?.message ?? "Failed to load overview";
      });
    } finally {
      runInAction(() => {
        this.loading = false;
      });
    }
  };

  reset = () => {
    this.items = [];
    this.loading = false;
    this.hasLoadedOnce = false;
    this.error = null;
  };
}

export const targetSetupOverviewStore = new TargetSetupOverviewStore();

export const useTargetSetupOverviewStore = () => targetSetupOverviewStore;
